<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' }">

    <div class="flex flex-col items-center my-10">
      <img class="object-contain w-12/12" src="@/assets/logo.png" />
    </div>
  </header>

  <!-- Seleccion de form -->
  <div class="h-2 bg-[#044e7d]"></div>

  <section id="formulario" >

    <div class="container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

      <h1 class="font-bold text-center text-xl">Para comenzar seleccione el tipo de acreditación</h1>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2">
        <div class="w-full px-2">
          <Field name="tipoAcreditacion" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoAcreditacion">
            <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="Tipo de acreditacion" class="input-base" :options="tiposAcreditaciones" optionLabel="descripcion" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoAcreditacion" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2">
        <div class="w-full px-2 mt-3 items-end flex justify-end">
          <router-link to="/credenciales" class="border border-[#0f3449] text-[#0f3449] hover:bg-[#0f3449] hover:text-white px-4 py-2 rounded-md transition-all duration-200" >
            YA ME ACREDITÉ
          </router-link>
        </div>  
      </div>

    </div> 

    <VisitanteSection v-if="formData.tipoAcreditacion?.id === 'V'" />
    <StaffSection v-if="formData.tipoAcreditacion?.id === 'S'" />
    <DisertanteSection v-if="formData.tipoAcreditacion?.id === 'D'" />
    <PrensaSection v-if="formData.tipoAcreditacion?.id === 'P'" />
    <EquiposComunicacionSection v-if="formData.tipoAcreditacion?.id === 'E'" />
    
  </section>


</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Field, ErrorMessage } from 'vee-validate';

import Select from 'primevue/select';

import jsonTiposAcreditaciones from '@/data/tiposAcreditaciones.json';
import { StringIdLabelEntity } from 'qreventos-suite/services';
import VisitanteSection from '@/components/VisitanteSection.vue';
import StaffSection from '@/components/StaffSection.vue';
import DisertanteSection from '@/components/DisertanteSection.vue';
import PrensaSection from '@/components/PrensaSection.vue';
import EquiposComunicacionSection from '@/components/EquiposComunicacionSection.vue';

interface TipoAcreditacion extends StringIdLabelEntity {}

export default defineComponent({
  name: 'FormSection',
  components: {
    Field, ErrorMessage, Select,
    VisitanteSection,
    StaffSection,
    DisertanteSection,
    PrensaSection,
    EquiposComunicacionSection
  },
  data() {
    return {
      isSubmitting: false,
      tiposAcreditaciones: jsonTiposAcreditaciones as TipoAcreditacion[],
      formData: {  
        tipoAcreditacion: undefined as unknown as TipoAcreditacion
      }
    };
  }, 
  created () {
    document.title = "Cumbre federal de logísitca 2026";
  }
});
</script>